import { createVNode as l, mergeProps as a } from "vue";
import n from "../node_modules/@pf-ui/pf-icon-svg/es/asn/UnlockFilledStandard.js";
import d from "../components/PfIcon.js";
const r = (t, o) => {
  const e = {
    ...t,
    ...o.attrs
  };
  return l(d, a(e, {
    icon: n
  }), null);
};
r.displayName = "UnlockFilledStandard";
r.inheritAttrs = !1;
export {
  r as default
};
